import { version } from '../../version.json';
import defaultConfig from '../../global-variables';

export function getVersion() {
  const branch = defaultConfig.env;
  const number = version || '';
  if (branch === number) return number;
  return `${number} (${branch.substring(0, 1).toLocaleUpperCase()})`;
}
